import React from "react";
import BlockInterface from '../editable_interface/BlockInterface/BlockInterface';
import Banner from '../components/Banner/Banner.js'
import './style.css';

export default function Conferences() {
    /////////////////////////////////////////////////////////////////////////////
    let image_name = "conferences.jpg";
    let is_video = false;
    /////////////////////////////////////////////////////////////////////////////
    return (
        <>
            <Banner src={image_name}></Banner>
            <BlockInterface pageName="Conferences"></BlockInterface>
        </>
    );
}
